import React from 'react'
import { useGetCoinExchangesQuery } from '../services/cryptoApi';
import {Row,Col,Avatar,Collapse,Typography} from 'antd';
import 'antd/dist/antd.css';
import millify from 'millify';
import HTMLReactParser from 'html-react-parser';


function Exchanges() {
  // const {data,isFetching} = useGetCoinExchangesQuery();
  // if(isFetching) return 'Loading...';
  // console.log(data)
  function callback(key) {
    console.log(key);
  }

  const { Panel } = Collapse;
  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
  return (
    <>
    <Row>
      <Col span={6}>Exchanges</Col>
      <Col span={6}>24h Trade Volume</Col>
      <Col span={6}>Markets</Col>
      <Col span={6}>Change</Col>
    </Row>

  <Row>  
  <Collapse defaultActiveKey={['1']} onChange={callback}>
    <Col span={24}>
    {/* <Panel header="This is panel header 1" key="1"> */}
    <Panel header=
    {
    <Row>
    <Col span={6}>
      Binance
    </Col>
    <Col span={6}>
      234B
    </Col>
    <Col span={6}>
      1.2K
    </Col>
    <Col span={6}>
      20.1%
    </Col>
    </Row>
    }
    key="1">
      <p>{text}</p>
    </Panel>
    {/* <Panel header="This is panel header 2" key="2">
      <p>{text}</p>
    </Panel>
    <Panel header="This is panel header 3" key="3">
      <p>{text}</p>
    </Panel> */}
    </Col>
  </Collapse>
    </Row>
    </>
  )
}

// function callback(key) {
//   console.log(key);
// }

// const text = `
//   A dog is a type of domesticated animal.
//   Known for its loyalty and faithfulness,
//   it can be found as a welcome guest in many households across the world.
// `;


// Final Code





// ReactDOM.render(
//   <Collapse onChange={callback}>
//     <Panel header="This is panel header 1" key="1">
//       <Collapse defaultActiveKey="1">
//         <Panel header="This is panel nest panel" key="1">
//           <p>{text}</p>
//         </Panel>
//       </Collapse>
//     </Panel>
//     <Panel header="This is panel header 2" key="2">
//       <p>{text}</p>
//     </Panel>
//     <Panel header="This is panel header 3" key="3">
//       <p>{text}</p>
//     </Panel>
//   </Collapse>,
//   mountNode,
// );import { Collapse } from 'antd';

// const { Panel } = Collapse;

// function callback(key) {
//   console.log(key);
// }

// const text = `
//   A dog is a type of domesticated animal.
//   Known for its loyalty and faithfulness,
//   it can be found as a welcome guest in many households across the world.
// `;

// ReactDOM.render(
//   <Collapse onChange={callback}>
//     <Panel header="This is panel header 1" key="1">
//       <Collapse defaultActiveKey="1">
//         <Panel header="This is panel nest panel" key="1">
//           <p>{text}</p>
//         </Panel>
//       </Collapse>
//     </Panel>
//     <Panel header="This is panel header 2" key="2">
//       <p>{text}</p>
//     </Panel>
//     <Panel header="This is panel header 3" key="3">
//       <p>{text}</p>
//     </Panel>
//   </Collapse>,
//   mountNode,
// );

export default Exchanges